import { render, staticRenderFns } from "./OmniTableSmall.vue?vue&type=template&id=2450f332&"
import script from "./OmniTableSmall.vue?vue&type=script&lang=js&"
export * from "./OmniTableSmall.vue?vue&type=script&lang=js&"
import style0 from "./OmniTableSmall.vue?vue&type=style&index=0&id=2450f332&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports